import {useUnifyAdminStore} from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import {CampaignNameInputWithHelperText} from '../Blocks/CampaignNameInputWithHelperText'
import get from 'lodash/get';
import { t } from 'i18next';

export const CampaignNameFrCAField = (): JSX.Element => {

    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);
    const updateCreateCampaignData = useUnifyAdminStore(
        (state) => state.updateCreateCampaignData
    );
    const permissions = useUnifyAdminStore(state => state.permissions);

    const name = get(campaignItems, 'name');

    const handleUpdateNameField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: 'name',
            value: {enUS: name?.enUS, enCA:name?.enCA, frCA: event.target.value},
        });
    };

    return (
        <StyledComponents.StyledCreateCampaignElementWrapper>
            <CampaignNameInputWithHelperText
                dataTestId="campaign-fr-name-input"
                errorMessage="Please enter Name"
                id="campaign-fr-name-abbr-input"
                inputDivider="left"
                label={t('campaigns.campaignNameFrCA')}
                name="name"
                onChange={handleUpdateNameField}
                placeholder={t('campaigns.campaignNameFrCAPlaceholder')}
                value={campaignItems.name?.frCA}
                customWidth={'100%'}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
                maxLength={100}
                textLength={`${campaignItems?.name?.frCA?.length || 0}/100`}
            />
        </StyledComponents.StyledCreateCampaignElementWrapper>
    );
};
